import { render, staticRenderFns } from "./TestimonialOverviewHandler.vue?vue&type=template&id=6dd17ec8&scoped=true&"
import script from "./TestimonialOverviewHandler.vue?vue&type=script&lang=js&"
export * from "./TestimonialOverviewHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd17ec8",
  null
  
)

export default component.exports